export const validationName = {
  required: "The field is required",
  pattern: {
    value: /^[A-Za-z][A-Za-z' -]*$/,
    message: "Use letters, spaces, apostrophes, or hyphens",
  },
  minLength: {
    value: 2,
    message: "The field must have at least 2 characters",
  },
  maxLength: {
    value: 30,
    message: "The field must have no more than 30 characters",
  },
};

export const validationEmail = {
  required: "The field is required",
  pattern: {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    message: "Invalid email address",
  },
};

export const validationPhone = {
  required: "The field is required",
  pattern: {
    value: /^\+?[\d\s().-]{10,20}$/,
    message: "Enter a valid phone number",
  },
};

export const validation = {
  required: "The field is required",
};
